<template>
  <div class="chart-demo">

    <div class="iotChart-content">

      <vueHighChart

        v-if="showChart"
        ref="dChart"

        :options="chartOptions"
        :redrawOnUpdate="true"
        :oneToOneUpdate="false"
        :animateOnUpdate="true"


        @update="onUpdated"/>

   
    </div>


 




  </div>
</template>



<script>


/*


<div v-if="false">
    <button
      class="set-buton"
      @click="clearDataSeries">
      set series button
    </button>

    <button
      class="chart-button"
      @click="setDataSeries(   [ [1,2,3,4,5,6], [0,1,2,3,4,7,8] ]  , 'New Title')"   >
      Set DataSeries
    </button>
</div>

*/






import { computed,  ref } from 'vue';                       // eslint-disable-line
import VueHighcharts from "vue3-highcharts";





/* eslint-disable */
const S_TEMP  = 0;     // temperature and humidity
const S_GAS   = 1;     // CO2 and TVOC
const S_BNO   = 2      // 9-axis sensor
const S_SND   = 3;     // sound level
const S_DIST  = 4;     // Distance 
const S_LUX   = 6;     // Light (LUX)

/* eslint-enable */





export default {

  name: 'ChartTemp',

  components: {
    'vueHighChart': VueHighcharts,
  },



 // ----------------------------------------------------
  // define all the variables for the DChart 
  // ----------------------------------------------------
  props: {
     
    sensorName: {                       // No use anymore
        type: String,
       
    },

  },


  // Instance method
  methods: {

    test()  {
        console.log("Invoke test method");
        //    this.$forceUpdate();
     },
  },




  setup(props, context) {


    console.log("----------- Reactive API -------------");
    // Attributes (Non-reactive object, equivalent to $attrs)
    console.log(context.attrs)

    // Slots (Non-reactive object, equivalent to $slots)
    console.log(context.slots)

    // Emit events (Function, equivalent to $emit)
    console.log(context.emit)

    // Expose public properties (Function)
    console.log(context.expose)
    console.log("----------- Reactive API End -------------");




    // ---------------------------------------------
    //  sensorType initialization
    // ----------------------------------------------

    let sensorType = ref( 0);


    sensorType.value = S_DIST;  





    const seriesData = ref(  []  );
    const chartHeight = ref( 450);
    let YAxisLabel = ref( [] );


    let chartTitle =  ref( "Temperatue and Humidity");



    // console.log(sensorType.value);
    console.log(chartHeight);


    seriesData.value = [ {  name: "Temperature ",    data: [ ],   animation: false,             type: 'spline', },
                         {  name: "Humidity  ",  data: [ ],    animation: false,      yAxis: 1 ,type: 'line' }, ];

 

    // ---------------------------------------------
    //  Component init setting (sensorType)
    // ----------------------------------------------


    switch (sensorType.value) {

        case S_TEMP:    // temperature and humidity
            YAxisLabel.value =   [{  min: 0, max: 100, lineWidth: 1, title: { text:  "Temperature (&degC)" } }, { min: 0, max: 100, lineWidth: 1, opposite: true, title: { text:  "Humidity (%) "}}];
            
            chartTitle.value = "Temperatue and Humidity Sensor";             
            seriesData.value = [ {  name: "Temperature ",    data: [ ],   animation: false,             type: 'spline', },
                         {  name: "Humidity  ",  data: [ ],    animation: false,      yAxis: 1 ,type: 'spline' }, ];
            break;

        case S_GAS:     // CO2 and TVOC
             YAxisLabel.value = [    { title: {  text: 'CO2 (ppm)' } }, { title: { text: 'TVOC (ppm)' }, opposite: true }];   

            seriesData.value = [ {  name: "CO2",    data: [ ],   animation: false,             type: 'spline', },
                         {  name: "TVOC  ",  data: [ ],    animation: false,      yAxis: 1 ,type: 'spline' }, ];
             chartTitle.value = "Environmental Gas Quality" ;            
            break;
        case S_BNO:     // 9-axis sensor
             YAxisLabel.value  = [    { title: {  text: 'RAW sensor value' } }];   

             seriesData.value = [ {  name: "Ax",    data: [ ],   animation: false,             type: 'spline', },
                        {  name: "Ay",    data: [ ],   animation: false,             type: 'spline', },  
                        {  name: "Az",    data: [ ],   animation: false,             type: 'spline', },

                        {  name: "Gx",    data: [ ],   animation: false,             type: 'spline', },
                        {  name: "Gy",    data: [ ],   animation: false,             type: 'spline', },  
                        {  name: "Gz",    data: [ ],   animation: false,             type: 'spline', },

                        {  name: "Mx",    data: [ ],   animation: false,             type: 'spline', },
                        {  name: "My",    data: [ ],   animation: false,             type: 'spline', },  
                        {  name: "Mz",    data: [ ],   animation: false,             type: 'spline', },

                         ];

             chartTitle.value = "9-axis Motion sensor value (Accelerometer, Gryo, Magnetometer)";        
             break;
        case S_SND:     // sound level
              YAxisLabel.value  = [    { title: {  text: 'Sound level raw value' } }];      

              seriesData.value = [ {  name: "Sound amplitude",    data: [ ],   animation: false,             type: 'spline', },
                         ];

              chartTitle.value = "Environmental Sound Level";              
              break;

          case S_DIST:    // distance  
              YAxisLabel.value  = [    {  min: 0, max: 100,  title: {   text: 'Distance (mm)' } },    ];     
              
              seriesData.value = [ {  name: "Distance",    data: [ ],   animation: false,             type: 'spline', },];

              chartTitle.value = "Time of Flight sensor (Proximity distance)" ;
              break;



        case S_LUX:    // distance and light sensor
              YAxisLabel.value  = [   { title: { text: 'Ambient Light Sensor (LUX)' }, opposite: true } ];     
              seriesData.value = [ {  name: "Light Intensity (LUX)",    data: [ ],   animation: false,             type: 'spline', },];
              chartTitle.value = "Light Sensor " ;
              break;

 

      } 




   let chartOptions =  computed(   () => (

         {
              time: {
                    useUTC: false,
                },

              credits: {
                enabled: false,
              },
              legend: {
                enbaled: true,
              },
              exporting: {
                enabled: false,
              },

              chart: {
                  marginRight: 80 // like left
              },

                title: {
                text: chartTitle.value,
                style: {
                  "font-family": "Avenir, Helvetica, Arial, sans-serif",
                  "-webkit-font-smoothing": "antialiased",
                  "-moz-osx-font-smoothing": "grayscale",
                  color: "#2c3e50",
                  "font-weight": "bold",
                  "font-size": "180%",
                },
              },

                xAxis: {
          type: "datetime",
          tickInterval: 86400 * 1000, // 1 day in ms
          labels: {
            rotation: 60,
          },
        },
              yAxis: YAxisLabel.value,

              series:  seriesData.value,
          }

          )  );



    const onUpdate = () => {
      console.log("chart updated!");
    }

 
    // ---------------------------------------------
    // Update the series into charts, optional for title String
    // ----------------------------------------------
    const setDataSeries = ( dataArr,  titleStr ) => {

        if (titleStr != null)
          chartTitle.value = titleStr;

        for (var i=0; i< dataArr.length; i++) 
            seriesData.value[i].data = dataArr[i] ; // [1,2,4,45,6]
        
    }


    // ---------------------------------------------
    // clear the chart Series
    // ----------------------------------------------
    const clearDataSeries = (  ) => {

        for (var i=0; i< seriesData.value.length ; i++) 
             seriesData.value[i].data.length = 0;
              
    }




   // setInterval( ()  => addCategoryAndSeries(), 2000);


    return {
      chartOptions,
      setDataSeries,     // set  DataSeries
      clearDataSeries,   // clear DataSeries
      onUpdate 
    };


  },



  mounted() {
      // ------------------------------------------------------
      // assign the current object into window.chart hierachy after the component is mounted in DOM
      // ------------------------------------------------------
      window.iotChartDist = this;
  },



  beforeUnmount() { 

    console.log("===> chartTemp destroy! ");
  },


  // ------------------------------------------------------
  // speed up the update for DOM when loading a lot of data
  // ------------------------------------------------------

  data: () => ({
    showChart: true,
  }),


  watch: {
    series: {
      handler() {
       
        // DOM is not update yet

        // this destroys the chart
        this.showChart = false;


        this.$nextTick(() => {     // defer the callback to be executed after next DOM update
            // DOM is now updated 
            // this renders a new one, with the new set of data
            this.showChart = true;

           
        });
      },
    },
  },



};








/*

// -------------- Global javascript function -------------------------
 
function  setFirebaseSeries() {                 

  // ------------------------------------------------------
  // assign the current object into window.chart hierachy
  // ------------------------------------------------------
  //console.log("this => " ,    window.chartObj.chartB    );

 // window.iotChartTemp.setDataSeries(   [ [8,8,3,4,5,6], [0,1,2,3,4,7,8] ]  , 'Temperature and Humidity');   

  window.iotChartTemp.setDataSeries(   [ [8,8,3,4,5,6], [0,1,2,3,4,7,8] ] );   
}                                             


 setTimeout( ()  => setFirebaseSeries(), 1000);
 //setInterval( ()  => setFirebaseSeries(), 5000);

*/


</script>



 

